import firebase from 'firebase/compat/app';
import 'firebase/compat/functions';

/**
 * @typedef {object} PasswordResetRequest
 * @property {string} url
 * @property {string} [email]
 * @property {string} [uid]
 * @property {boolean} [forceReset]
 */

/**
 * @param {string} url
 * @param {string} [email]
 * @param {string} [uid]
 * @returns {Promise<firebase.functions.HttpsCallableResult>}
 */
export function requestPasswordReset(url, email, uid) {
  return _callPasswordReset({ url, email, uid });
}

/**
 * @param {string} uid
 * @param {string} url
 * @returns {Promise<firebase.functions.HttpsCallableResult>}
 */
export function forcePasswordReset(uid, url) {
  return _callPasswordReset({ forceReset: true, uid, url });
}

/**
 * @param {PasswordResetRequest} options
 * @returns {Promise<firebase.functions.HttpsCallableResult>}
 */
function _callPasswordReset(options) {
  return firebase.functions().httpsCallable('sendPasswordResetEmail')(options);
}
